import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContextMenuService {
  private menuSubscription = new Subject<any>();

  triggerMenuItem(data: any) {
    this.menuSubscription.next(data);
  }

  listenContextMenuChanges() {
    return this.menuSubscription.asObservable();
  }

}
